/* Impulse Padel — paid textile personalization on selected product pages. */
(() => {
  const ELIGIBLE_HANDLES = new Set([
    't-shirt-technique-padel-homme-impulse',
    't-shirt-padel-homme-essentiel-recycle',
    't-shirt-technique-de-padel-femme',
    'debardeur-de-padel-bicolore-femme',
  ]);
  const TEXT_VARIANT_ID = 54802471780689;
  const FLAG_VARIANT_ID = 54802471813457;
  const PANEL_ID = 'impulse-personalization';
  const STYLE_ID = 'impulse-personalization-styles';
  const CART_NOTICE_ID = 'impulse-personalization-cart-notice';

  const handle = decodeURIComponent(location.pathname.split('/products/')[1] || '').split('/')[0];
  const eligibleProduct = ELIGIBLE_HANDLES.has(handle);

  const styles = `
    #${PANEL_ID}{margin:0 0 18px;border:1px solid #d8dce5;border-radius:14px;background:#fff;overflow:hidden;color:#080b1c}
    #${PANEL_ID} *{box-sizing:border-box}
    #${PANEL_ID} .ip-personalization__toggle{display:flex;align-items:center;gap:11px;padding:15px 16px;cursor:pointer;font-weight:700;line-height:1.3}
    #${PANEL_ID} input[type="checkbox"]{width:20px;height:20px;min-width:20px;margin:0;accent-color:#1769e8}
    #${PANEL_ID} .ip-personalization__toggle span{flex:1}
    #${PANEL_ID} .ip-personalization__toggle small{font-size:12px;color:#1769e8;white-space:nowrap}
    #${PANEL_ID} .ip-personalization__content{padding:0 16px 16px;border-top:1px solid #edf0f5;background:#fafbfe}
    #${PANEL_ID} .ip-personalization__content[hidden]{display:none!important}
    #${PANEL_ID} .ip-personalization__field{display:block;padding-top:14px}
    #${PANEL_ID} .ip-personalization__label{display:flex;justify-content:space-between;gap:12px;margin-bottom:8px;font-size:14px;font-weight:700}
    #${PANEL_ID} .ip-personalization__price{color:#1769e8;white-space:nowrap}
    #${PANEL_ID} .ip-personalization__text{width:100%;min-height:46px;padding:11px 13px;border:1px solid #b8bfcc;border-radius:9px;background:#fff;color:#080b1c;font:inherit;text-transform:none}
    #${PANEL_ID} .ip-personalization__text:focus{outline:2px solid #1769e8;outline-offset:1px;border-color:#1769e8}
    #${PANEL_ID} .ip-personalization__meta{display:flex;justify-content:space-between;gap:12px;margin-top:6px;font-size:12px;color:#626a78}
    #${PANEL_ID} .ip-personalization__flag{display:flex;align-items:center;gap:10px;margin-top:14px;padding:12px;border:1px solid #d8dce5;border-radius:10px;background:#fff;cursor:pointer}
    #${PANEL_ID} .ip-personalization__flag span{flex:1;font-size:14px;font-weight:650}
    #${PANEL_ID} .ip-personalization__country[hidden]{display:none!important}
    #${PANEL_ID} .ip-personalization__notice{margin:12px 0 0;font-size:12px;line-height:1.45;color:#626a78}
    #${PANEL_ID} .ip-personalization__total{display:flex;justify-content:space-between;gap:12px;margin:14px 0 0;padding-top:12px;border-top:1px solid #d8dce5;font-size:14px;font-weight:750}
    #${PANEL_ID} .ip-personalization__error{margin:9px 0 0;color:#b42318;font-size:13px;font-weight:650}
    #${PANEL_ID} .ip-personalization__error:empty{display:none}
    product-form-component.ip-personalization-active [ref="acceleratedCheckoutButtonContainer"],
    product-form-component.ip-personalization-active .shopify-payment-button{display:none!important}
    #${CART_NOTICE_ID}{margin:16px 0;padding:16px;border:1px solid #1769e8;border-radius:12px;background:#f4f8ff;color:#080b1c}
    #${CART_NOTICE_ID} .ip-cart-notice__title{margin:0 0 8px;font-size:16px;font-weight:750}
    #${CART_NOTICE_ID} .ip-cart-notice__text{margin:0 0 12px;font-size:13px;line-height:1.5}
    #${CART_NOTICE_ID} .ip-cart-notice__accept{display:flex;align-items:flex-start;gap:10px;font-size:13px;font-weight:650;line-height:1.45;cursor:pointer}
    #${CART_NOTICE_ID} .ip-cart-notice__error{margin:8px 0 0;color:#b42318;font-size:13px;font-weight:650}
    #${CART_NOTICE_ID} .ip-cart-notice__error:empty{display:none}
    [data-ip-checkout-disabled="true"]{opacity:.55!important;cursor:not-allowed!important;pointer-events:auto!important}
    body.ip-personalization-cart-active .dynamic-checkout-cart,
    body.ip-personalization-cart-active shopify-accelerated-checkout-cart{display:none!important}
    @media(max-width:749px){#${PANEL_ID}{margin-bottom:14px}#${PANEL_ID} .ip-personalization__toggle{padding:14px}#${PANEL_ID} .ip-personalization__content{padding:0 14px 14px}}
  `;

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    document.head.appendChild(style);
  }

  function createPanel() {
    const panel = document.createElement('section');
    panel.id = PANEL_ID;
    panel.setAttribute('aria-label', 'Personnalisation du textile');
    panel.innerHTML = `
      <label class="ip-personalization__toggle">
        <input type="checkbox" data-ip-personalization-toggle>
        <span>Ajouter une personnalisation</span>
        <small>+5 €</small>
      </label>
      <div class="ip-personalization__content" data-ip-personalization-content hidden>
        <label class="ip-personalization__field">
          <span class="ip-personalization__label">
            <span>Texte personnalisé au dos</span>
            <span class="ip-personalization__price">+5 €</span>
          </span>
          <input class="ip-personalization__text" data-ip-personalization-text type="text" maxlength="15" placeholder="Votre texte" autocomplete="off" autocapitalize="characters">
        </label>
        <div class="ip-personalization__meta">
          <span>15 caractères maximum, espaces compris</span>
          <span data-ip-personalization-count>0/15</span>
        </div>
        <label class="ip-personalization__flag">
          <input type="checkbox" data-ip-personalization-flag>
          <span>Ajouter un drapeau</span>
          <strong class="ip-personalization__price">+2 €</strong>
        </label>
        <label class="ip-personalization__field ip-personalization__country" data-ip-personalization-country-wrap hidden>
          <span class="ip-personalization__label"><span>Pays du drapeau</span></span>
          <input class="ip-personalization__text" data-ip-personalization-country type="text" maxlength="40" placeholder="Ex. France" autocomplete="country-name">
        </label>
        <p class="ip-personalization__total"><span>Supplément personnalisation</span><span data-ip-personalization-total>+5 €</span></p>
        <p class="ip-personalization__notice">Un article personnalisé ne peut pas être repris ou échangé pour un changement d’avis, une erreur de taille ou une erreur dans le texte validé. Les garanties légales restent applicables en cas de défaut ou de non-conformité.</p>
        <p class="ip-personalization__error" data-ip-personalization-error role="alert" aria-live="polite"></p>
      </div>`;
    return panel;
  }

  function mountProduct() {
    if (!eligibleProduct) return;
    installStyles();
    if (document.getElementById(PANEL_ID)) return;
    const productForm = document.querySelector('main product-form-component');
    if (!productForm) return;

    const panel = createPanel();
    productForm.insertAdjacentElement('beforebegin', panel);

    const toggle = panel.querySelector('[data-ip-personalization-toggle]');
    const content = panel.querySelector('[data-ip-personalization-content]');
    const text = panel.querySelector('[data-ip-personalization-text]');
    const flag = panel.querySelector('[data-ip-personalization-flag]');
    const countryWrap = panel.querySelector('[data-ip-personalization-country-wrap]');
    const country = panel.querySelector('[data-ip-personalization-country]');
    const count = panel.querySelector('[data-ip-personalization-count]');
    const total = panel.querySelector('[data-ip-personalization-total]');
    const error = panel.querySelector('[data-ip-personalization-error]');

    const update = () => {
      content.hidden = !toggle.checked;
      productForm.classList.toggle('ip-personalization-active', toggle.checked);
      text.required = toggle.checked;
      count.textContent = `${text.value.length}/15`;
      total.textContent = flag.checked ? '+7 €' : '+5 €';
      countryWrap.hidden = !flag.checked;
      country.required = toggle.checked && flag.checked;
      if (!toggle.checked) {
        text.value = '';
        flag.checked = false;
        country.value = '';
        countryWrap.hidden = true;
        count.textContent = '0/15';
        error.textContent = '';
      }
    };

    toggle.addEventListener('change', () => {
      update();
      if (toggle.checked) window.setTimeout(() => text.focus(), 80);
    });
    text.addEventListener('input', () => {
      count.textContent = `${text.value.length}/15`;
      error.textContent = '';
    });
    flag.addEventListener('change', update);
    country.addEventListener('input', () => { error.textContent = ''; });
    update();
  }

  async function addPersonalizedProduct(event, form, panel) {
    const toggle = panel.querySelector('[data-ip-personalization-toggle]');
    if (!toggle?.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const textInput = panel.querySelector('[data-ip-personalization-text]');
    const flagInput = panel.querySelector('[data-ip-personalization-flag]');
    const countryInput = panel.querySelector('[data-ip-personalization-country]');
    const error = panel.querySelector('[data-ip-personalization-error]');
    const customText = textInput.value.trim().replace(/\s+/g, ' ');

    if (!customText) {
      error.textContent = 'Saisissez le texte à imprimer au dos.';
      textInput.focus();
      return;
    }
    if (customText.length > 15) {
      error.textContent = 'Le texte ne peut pas dépasser 15 caractères.';
      textInput.focus();
      return;
    }
    const flagCountry = countryInput.value.trim().replace(/\s+/g, ' ');
    if (flagInput.checked && !flagCountry) {
      error.textContent = 'Indiquez le pays du drapeau souhaité.';
      countryInput.focus();
      return;
    }

    const variantId = Number(form.querySelector('[name="id"]')?.value);
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
    if (!variantId) {
      error.textContent = 'Choisissez une taille et une couleur avant de continuer.';
      return;
    }

    const title = document.querySelector('main h1')?.textContent?.trim() || 'Textile Impulse Padel';
    const productProperties = {
      'Texte personnalisé au dos': customText,
      ...(flagInput.checked ? {'Drapeau demandé': flagCountry} : {}),
    };
    const linkedProperties = {
      'Pour': title,
      'Texte': customText,
      '_Produit lié': String(variantId),
    };
    const items = [
      {id: variantId, quantity, properties: productProperties},
      {id: TEXT_VARIANT_ID, quantity, properties: linkedProperties},
    ];
    if (flagInput.checked) {
      items.push({
        id: FLAG_VARIANT_ID,
        quantity,
        properties: {'Pour': title, 'Pays': flagCountry, '_Produit lié': String(variantId)},
      });
    }

    const button = form.querySelector('button[name="add"]');
    const previousText = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
    }
    error.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items}),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Ajout impossible.');
      window.location.assign('/cart');
    } catch (requestError) {
      error.textContent = requestError.message || 'Une erreur est survenue. Réessayez.';
      if (button) {
        button.disabled = false;
        button.textContent = previousText || 'Ajouter au panier';
      }
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const panel = document.getElementById(PANEL_ID);
    if (panel) addPersonalizedProduct(event, form, panel);
  }, true);

  let cartGuardLoading = false;
  async function mountCartGuard() {
    if (location.pathname !== '/cart' || document.getElementById(CART_NOTICE_ID) || cartGuardLoading) return;
    cartGuardLoading = true;
    try {
      const cart = await fetch('/cart.js', {headers: {Accept: 'application/json'}}).then((response) => response.json());
      const hasPersonalizedItem = cart.items?.some((item) => item.properties?.['Texte personnalisé au dos']);
      if (!hasPersonalizedItem) return;

      installStyles();
      document.body.classList.add('ip-personalization-cart-active');
      const checkoutButtons = [...document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')];
      const firstCheckout = checkoutButtons[0];
      if (!firstCheckout) return;

      const notice = document.createElement('section');
      notice.id = CART_NOTICE_ID;
      notice.innerHTML = `
        <p class="ip-cart-notice__title">Confirmation requise — article personnalisé</p>
        <p class="ip-cart-notice__text">Votre panier contient un article personnalisé. Conformément à l’article L221-28, 3° du Code de la consommation, le droit de rétractation ne s’applique pas à cet article. Il ne pourra pas être repris ou échangé pour un changement d’avis, une erreur de taille ou une erreur dans le texte validé. Les garanties légales restent applicables en cas de défaut ou de non-conformité.</p>
        <label class="ip-cart-notice__accept">
          <input type="checkbox" data-ip-personalization-cart-accept>
          <span>J’ai vérifié la taille et le texte, et j’accepte les conditions applicables aux articles personnalisés.</span>
        </label>
        <p class="ip-cart-notice__error" data-ip-personalization-cart-error role="alert" aria-live="polite"></p>`;
      const insertionTarget = firstCheckout.closest('.cart__checkout-button, .cart__ctas, .cart__footer, [class*="checkout"]') || firstCheckout;
      insertionTarget.insertAdjacentElement('beforebegin', notice);

      const accept = notice.querySelector('[data-ip-personalization-cart-accept]');
      const error = notice.querySelector('[data-ip-personalization-cart-error]');
      const setCheckoutState = (accepted) => {
        checkoutButtons.forEach((button) => {
          button.setAttribute('data-ip-checkout-disabled', String(!accepted));
          button.setAttribute('aria-disabled', String(!accepted));
          if ('disabled' in button) button.disabled = !accepted;
        });
      };
      setCheckoutState(false);

      accept.addEventListener('change', async () => {
        error.textContent = '';
        setCheckoutState(accept.checked);
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', Accept: 'application/json'},
            body: JSON.stringify({attributes: {'Conditions personnalisation acceptées': accept.checked ? 'Oui' : ''}}),
          });
        } catch (_) {
          if (accept.checked) {
            accept.checked = false;
            setCheckoutState(false);
            error.textContent = 'La confirmation n’a pas pu être enregistrée. Réessayez.';
          }
        }
      });

      document.addEventListener('click', (event) => {
        const checkout = event.target.closest?.('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
        if (checkout && !accept.checked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          error.textContent = 'Cochez la case pour continuer vers le paiement.';
          accept.focus();
        }
      }, true);
    } finally {
      cartGuardLoading = false;
    }
  }

  const mountAll = () => { mountProduct(); mountCartGuard(); };
  document.addEventListener('DOMContentLoaded', mountAll);
  document.addEventListener('shopify:section:load', mountAll);
  mountAll();

  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mountAll();
    });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
